import store from '../store'
import router from '@/router/router'
import axios from 'axios'

export const API_BASE_URL = window.config.VUE_APP_API_BASE_URL

export const apiClient = createApiClient()
export const apiClientPublic = createApiClient(API_BASE_URL, false)

export function createApiClient(
  baseURL = API_BASE_URL,
  withCredentials = true,
  options = {}
) {
  const instance = axios.create({
    baseURL: baseURL,
    withCredentials: withCredentials,
    ...options
  })
  if (withCredentials) {
    instance.interceptors.request.use(config => {
      const token = store.getters.jwt
      if (token) {
        config.headers.Authorization = `bearer ${token}`
      }
      return config
    })
  }
  return instance
}

export function createCancelToken() {
  return axios.CancelToken.source()
}

export function handleResponse(response) {
  const { data } = response
  if (!(response.status >= 200 && response.status <= 299)) {
    const fromCMSService = response.request.responseURL.includes(
      window.config.VUE_APP_CMS_API_BASE_URL
    )
    if (response.status === 401 && !fromCMSService) {
      // commit only when the user is already loggedIn
      if (store.getters.isAuthenticated) {
        store.dispatch('sessionTimeOut')
      }
    }
    const error = data || response
    return Promise.reject(error)
  }
  return data
}

export function handleError(e) {
  if (e instanceof Error && e.message === 'Network Error') {
    e.response = { status: '503' }
    // console.error('Network Error:', e)
    return Promise.reject(e)
  }
  if (!(e?.response?.status === 200)) {
    const fromCMSService = e.request.responseURL.includes(
      window.config.VUE_APP_CMS_API_BASE_URL
    )
    let requiresAuth = true
    try {
      requiresAuth = router.app._route.meta.requiresAuth
    } catch (error) {
      // do nothing
    }

    if (e.response.status === 401 && !fromCMSService && requiresAuth) {
      // commit only when the user is already loggedIn
      if (store.getters.isAuthenticated) {
        store.dispatch('sessionTimeOut')
      }
    }
    return Promise.reject(e)
  }
  return Promise.reject(e)
}

export function getHeader(
  additionalOptions = {},
  contentType = 'application/json'
) {
  const token = store?.getters?.jwt
  const headers = { 'Content-Type': contentType }
  if (token) {
    headers.Authorization = `bearer ${token}`
  }
  return { headers, ...additionalOptions }
}

export function getOrganizationIdParamString() {
  return store?.getters?.selectedOrganization?.id
    ? '?organizationId=' + store?.getters?.selectedOrganization?.id
    : ''
}

export function getOrganizationId() {
  return store?.getters?.selectedOrganization?.id
}

export function buildQueryString(params, withOrganizationId = false) {
  if (withOrganizationId) {
    const orgParam = getOrganizationIdParamString()
    if (orgParam) {
      params = { ...params, ...orgParam }
    }
  }
  return (
    Object.entries(params)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, value]) => value !== null && value !== undefined)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join('&')
  )
}
